<template>
  <div class="container">
    <div class="content">
      <div class="signin-main">
        <div class="header">注册账号</div>
        <Form ref="userForm" :model="userForm" :label-width="120" :rules="ruleValidate">
          <div class="title">账户信息</div>
          <FormItem label="账号" prop="name">
            <Input v-model="userForm.name" placeholder="账号"></Input>
          </FormItem>
          <FormItem required label="登录密码" prop="password">
            <Input v-model="userForm.password" type="password" placeholder="登录密码"></Input>
          </FormItem>
          <FormItem required label="重复输入密码" prop="confirmPassword">
            <Input v-model="userForm.confirmPassword" type="password" placeholder="重复输入密码"></Input>
          </FormItem>
          <div class="title">公司信息</div>
          <div style="position:relative;left:-90px;width:590px;">
            <FormItem required label="统一社会信用代码" prop="creditCode" :label-width="210">
              <Input v-model="userForm.creditCode" placeholder="请确保统一社会信用代码准确有效"></Input>
            </FormItem>
          </div>
          <FormItem label="公司名称" prop="company">
            <Input disabled="disabled" v-model="userForm.company" placeholder="请输入统一社会信用代码（自动识别）" id="company-input"></Input>
          </FormItem>
          <FormItem label="行业分类" prop="industryCategory">
            <!-- <Input v-model="userForm.industryCategory" placeholder="行业分类"></Input> -->
            <Select v-model="userForm.industryCategory">
              <Option value="企业单位">企业单位</Option>
              <Option value="事业或社会团体">事业或社会团体</Option>
              <Option value="个体经营">个体经营</Option>
              <Option value="其他">其他</Option>
            </Select>
          </FormItem>
          <FormItem label="公司电话" prop="companyPhone">
            <Input v-model="userForm.companyPhone" placeholder="公司电话"></Input>
          </FormItem>
          <div class="title">注册人信息</div>
          <FormItem label="真实姓名" prop="realName">
            <Input v-model="userForm.realName" placeholder="真实姓名"></Input>
          </FormItem>
          <FormItem label="电子邮箱" prop="Email">
            <Input v-model="userForm.Email" placeholder="电子邮箱"></Input>
          </FormItem>
          <div>
            <FormItem required label="邮箱验证码" prop="validEmail" style="width: 320px;display:inline-block">
              <Input v-model="userForm.validEmail" placeholder="邮箱验证码" style="width: 200px"></Input>
            </FormItem>
            <Button type="primary" size="small" style="margin:5px 20px;" @click="getMailCode" :disabled="mailDisabled">{{mailValidText}}</Button>
          </div>
          <FormItem label="手机号码" prop="telphone">
            <Input v-model="userForm.telphone" placeholder="手机号码"></Input>
          </FormItem>
          <div>
            <FormItem required label="手机验证码" prop="validPhone" style="width: 320px;display:inline-block">
              <Input v-model="userForm.validPhone" placeholder="手机验证码" style="width: 200px"></Input>
            </FormItem>
            <Button type="primary" size="small" style="margin:5px 20px;" @click="getPhoneCode" :disabled="phoneDisabled">{{phoneValidText}}</Button>
          </div>
          <FormItem>
            <Button type="primary" @click="handleSubmit">注册</Button>
            <Button @click="handleBack" style="margin-left: 8px">返回</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
// 租户
const state = 1

import ajax from "../lib/ajax";
import Util from "../lib/util";
import axios from "axios"
import { setInterval, clearInterval } from 'timers';

export default {
  name: 'signin',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码不少于6位'))
      } else {
        if (this.$refs.userForm.confirmPassword !== '') {
          this.$refs.userForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmpwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.userForm.password) {
        callback(new Error('确认密码与密码不一致'))
      } else {
        callback()
      }
    }
    const validateValidPhone = (rule, value, callback) => {
      let phoneValidCode = '000000' + this.phoneValidCode * 1717
      phoneValidCode = phoneValidCode.slice(-6)
      if (value === '') {
        callback(new Error('请输入手机验证码'))
      } else if (this.userForm.validPhone !== phoneValidCode || this.userForm.telphone !== this.getValidCodePhone) {
        callback(new Error('手机验证码不正确'))
      } else {
        callback()
      }
    }
    const validateValidMail = (rule, value, callback) => {
      let mailValidCode = '000000' + this.mailValidCode * 1717
      mailValidCode = mailValidCode.slice(-6)
      if (value === '') {
        callback(new Error('请输入邮箱验证码'))
      } else if (this.userForm.validEmail !== mailValidCode || this.userForm.Email !== this.getValidCodeMail) {
        callback(new Error('邮箱验证码不正确'))
      } else {
        callback()
      }
    }
    const validateCreditCode = async (rule, value, callback) => {
      if (value === '') {
        this.userForm.company = ''
        callback(new Error('请输入统一社会信用代码'))
      } else {
        const url = `https://www.creditchina.gov.cn/api/public_search/getCreditCodeFacades?keyword=${value}&filterManageDept=0&filterOrgan=0&filterDivisionCode=0&page=1&pageSize=10`
        // 这里只能使用不附加任何请求头的请求库
        let rep = await axios.get(url)

        if (rep.data.message === '成功') {
          if (this.userForm.creditCode === rep.data.results[0].creditCode) {
            this.userForm.company = rep.data.results[0].entname
          }
          callback()
        } else {
          this.userForm.company = ''
          callback(new Error('请确认您输入的统一社会信用代码'))
        }
      }
    }
    return {
      userForm: {
        name: '',
        password: '',
        confirmPassword: '',
        company: '',
        creditCode: '',
        industryCategory: '',
        companyPhone: '',
        realName: '',
        Email: '',
        telphone: '',
        validPhone: '',
        validEmail: '',
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入会员名' }
        ],
        password: [
          { validator: validatePass, trigger: 'change' }
        ],
        confirmPassword: [
          { validator: validateConfirmpwd, trigger: 'change' }
        ],
        company: [
          { required: true, message: '公司名称不能为空' }
        ],
        creditCode: [
          { validator: validateCreditCode, trigger: 'blur' }
        ],
        industryCategory: [
          { required: true, message: '请输入行业分类' }
        ],
        companyPhone: [
          { required: true, message: '请输入公司电话' },
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '请检查您输入的号码，(格式：000-1234567,15525252525)', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入真实姓名' }
        ],
        Email: [
          { required: true, message: '请输入电子邮箱' },
          { type: 'email', message: '请输入正确的邮箱' }
        ],
        telphone: [
          { required: true, message: '请输入手机号码' },
          { type: 'string', pattern: /1[0-9]{10}$/, message: '请检查您输入的号码', trigger: 'blur' }
        ],
        validPhone: [
          { validator: validateValidPhone, trigger: 'blur' }
        ],
        validEmail: [
          { validator: validateValidMail, trigger: 'blur' }
        ]
      },
      phoneValidCode: '',
      mailValidCode: '',
      getValidCodePhone: '',
      getValidCodeMail: '',
      mailDisabled: false,
      phoneDisabled: false,
      mailInterval: '',
      phoneInterval: '',
      mailValidText: '获取邮箱验证码',
      phoneValidText: '获取手机验证码',
      mailCount: 60,
      phoneCount: 60
    }
  },
  mounted() {
    Util.abp.multiTenancy.setTenantIdCookie(state);
  },
  methods: {
    handleSubmit() {
      this.spinShow('正在验证注册，请稍候')
      this.$refs['userForm'].validate(async valid => {
        if (valid) {
          const data = {
            name: this.userForm.realName,
            userName: this.userForm.name,
            emailAddress: this.userForm.Email,
            password: this.userForm.password,
            phoneNumber: this.userForm.telphone,
            companyInput: {
              companyNo: this.userForm.creditCode,
              companyName: this.userForm.company,
              companyType: this.userForm.industryCategory,
              comPanyTel: this.userForm.companyPhone
            }
          }
          try {
            let rep = await ajax.post('/api/services/app/Account/Register', data)
            if (rep.data.success) {
              this.$Modal.success({
                title: '注册',
                content: '注册成功',
                okText: '确定',
                onOk: () => {
                  this.$router.push({ name: 'login' })
                }
              })
            } else {
              this.$Message.success('注册失败')
            }
            this.$Spin.hide()
          } catch (err) {
            this.$Spin.hide()
            this.$Message.success('注册失败')
          }
        } else {
          this.$Spin.hide()
        }
      })
    },
    handleBack() {
      this.$router.push({ name: 'login' })
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', text)
          ])
        }
      })
    },
    getPhoneCode() {
      this.$refs.userForm.validateField('telphone', async valid => {
        // valid返回错误信息
        if (!valid) {
          // 倒计时
          this.validCount('phone')
          //发送请求
          let url = 'https://wx.chinapsp.cn/api3/phoneValidate'
          this.phoneValidCode = this.getValidCode()
          this.getValidCodePhone = this.userForm.telphone
          let params = {
            validateCode: this.phoneValidCode,
            phone: this.userForm.telphone
          }
          let rep = await axios({
            methods: 'get',
            url: url,
            params: params
          })
          if (rep.data.message === '请勿重复发送') {
            this.$Message.success('发送过于频繁，请一分钟后再尝试')
          }
        }
      })
    },
    getMailCode() {
      this.$refs.userForm.validateField('Email', async valid => {
        // valid返回错误信息
        if (!valid) {
          // 倒计时
          this.validCount('mail')
          //发送请求
          let url = 'https://wx.chinapsp.cn/api3/mailValidate'
          this.mailValidCode = this.getValidCode()
          this.getValidCodeMail = this.userForm.Email
          let params = {
            validateCode: this.mailValidCode,
            toMail: this.userForm.Email
          }
          let rep = await axios({
            methods: 'get',
            url: url,
            params: params
          })
          if (rep.data.message === '请勿重复发送') {
            this.$Message.error('发送过于频繁，请一分钟后再尝试')
          }
        }
      })
    },
    getValidCode() {
      const num = '0123456789'
      let resultNum = ''
      let time = 6
      while (time--) {
        resultNum += num[Math.floor(Math.random() * 10)]
      }
      return resultNum
    },
    validCount(type) {
      if (type === 'phone') {
        this.phoneDisabled = true
        this.phoneInterval = setInterval(() => {
          this.phoneCount--
          if (this.phoneCount > 0) {
            this.phoneValidText = `重新获取(${this.phoneCount})`
          } else {
            clearInterval(this.phoneInterval)
            this.phoneValidText = `获取手机验证码`
            this.phoneDisabled = false
            this.phoneCount = 60
          }
        }, 1000)
      }
      if (type === 'mail') {
        this.mailDisabled = true
        this.mailInterval = setInterval(() => {
          this.mailCount--
          if (this.mailCount > 0) {
            this.mailValidText = `重新获取(${this.mailCount})`
          } else {
            clearInterval(this.mailInterval)
            this.mailValidText = `获取邮箱验证码`
            this.mailDisabled = false
            this.mailCount = 60
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="less" scope>
.container {
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100%;
  background: #f0f2f5;
}
@media (min-width: 768px) {
  .container {
    background-image: url(https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg);
    background-repeat: no-repeat;
    background-position: center 110px;
    background-size: 100%;
    font-size: 18px;
  }
  .content {
    padding: 112px 0 24px;
  }
}
.content {
  height: 100%;
  padding: 32px 0;
  -ms-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: auto;
}
.signin-main {
  width: 500px;
  position: relative;
  margin: 0 auto;
  .header {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
  }
  .title {
    margin-bottom: 10px;
    padding-bottom: 5px;
    color: #ff5722;
    border-bottom: 1px solid #ddd;
  }
}
#company-input .ivu-input,
.ivu-input-disabled {
  color: #000 !important;
}
</style>
